"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.datePickerInputSchema = void 0;
exports.default = DatePickerInput;
const jsx_runtime_1 = require("react/jsx-runtime");
const x_date_pickers_1 = require("@mui/x-date-pickers");
const AdapterDateFnsV3_1 = require("@mui/x-date-pickers/AdapterDateFnsV3");
const react_hook_form_1 = require("react-hook-form");
const zod_1 = require("zod");
exports.datePickerInputSchema = ((options) => {
    return {
        options,
        create: (fieldName, validation) => {
            return zod_1.z.object({ [fieldName]: validation });
        },
    };
})({
    // validations:
    default: zod_1.z.date({ invalid_type_error: 'Required' }),
    notRequired: zod_1.z.date(),
});
function DatePickerInput(_a) {
    var { label, name, helperText, required = true, desktopMode = false, autoComplete = 'off', minDate, maxDate, slotProps, disabled = false } = _a, props = __rest(_a, ["label", "name", "helperText", "required", "desktopMode", "autoComplete", "minDate", "maxDate", "slotProps", "disabled"]);
    const { control } = (0, react_hook_form_1.useFormContext)();
    const { field, formState: { errors }, } = (0, react_hook_form_1.useController)({ name, control });
    const error = errors[name];
    return ((0, jsx_runtime_1.jsx)(x_date_pickers_1.LocalizationProvider, { dateAdapter: AdapterDateFnsV3_1.AdapterDateFns, children: (0, jsx_runtime_1.jsx)(x_date_pickers_1.DatePicker, Object.assign({}, field, { label: label, slotProps: Object.assign({ textField: Object.assign(Object.assign({}, field), { error: !!error, helperText: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (error === null || error === void 0 ? void 0 : error.message) || helperText }), required, fullWidth: true, autoComplete }) }, slotProps), minDate: minDate, maxDate: maxDate, desktopModeMediaQuery: desktopMode ? '@media (min-width: 0)' : undefined, disabled: disabled }, props)) }));
}
//# sourceMappingURL=DatePickerInput.js.map